/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* The resource\'s environment: production, internal production, or staging. 
*/
export enum Environment {
  Prod = 'PROD',
  ProdInternal = 'PROD_INTERNAL',
  Stage = 'STAGE',
  EnvironmentUnspecified = 'ENVIRONMENT_UNSPECIFIED'
}
